import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';

export interface GetShipmentVendorBranchRequestParams {
  customerKey: number;
}

export const getShipmentVendorBranchAPI = (params: GetShipmentVendorBranchRequestParams) => {
  return axiosInstance.request({
    url: `${API.PRIMARY}/GetBranchsByCustomer`,
    method: 'get',
    params,
  });
};

export type ShipmentVendorBranchResponse = {
  branchKey: string; // "67416"
  branchDesc: string;
}[];

export const fetchShipmentVendorBranch = async (
  params: GetShipmentVendorBranchRequestParams,
): Promise<ShipmentVendorBranchResponse> => {
  const response: AxiosResponse<ShipmentVendorBranchResponse> = await getShipmentVendorBranchAPI(params);
  return response.data;
};
